
export const apiURL = 'https://codefish.io/api';
export const mediaUrl = 'https://codefish.io/';

